<template>
  <section class="section container pt-0">
    <chatbots-datatable />
  </section>
</template>

<script>
import ChatbotsDatatable from "./chatbots_datatable/Index.vue";

export default {
  name: "WhatsappChatbots",
  components: {
    ChatbotsDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
